(() => {
  const storageKey = 'burvonti-cart-promo-code';

  const storeCode = (code) => {
    try {
      if (code) window.sessionStorage.setItem(storageKey, code);
      else window.sessionStorage.removeItem(storageKey);
    } catch (error) {
      // Discount application remains available when browser storage is blocked.
    }
  };

  const hydratePromo = () => {
    const input = document.querySelector('[data-burvonti-promo-input]');
    if (!input || input.value) return;
    try {
      input.value = window.sessionStorage.getItem(storageKey) || '';
    } catch (error) {
      // No-op in restricted browser modes.
    }
  };

  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-burvonti-promo-input]')) return;
    storeCode(event.target.value.trim());
    const promo = event.target.closest('[data-burvonti-promo]');
    const status = promo && promo.querySelector('[data-burvonti-promo-status]');
    if (status) {
      status.textContent = '';
      status.classList.remove('is-error');
    }
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-burvonti-promo-save]');
    if (!button) return;
    const promo = button.closest('[data-burvonti-promo]');
    const input = promo && promo.querySelector('[data-burvonti-promo-input]');
    const status = promo && promo.querySelector('[data-burvonti-promo-status]');
    const code = input ? input.value.trim() : '';
    if (!code) {
      if (status) {
        status.textContent = 'Enter a promo code.';
        status.classList.add('is-error');
      }
      if (input) input.focus();
      return;
    }
    storeCode(code);
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const redirect = `${root}cart`;
    window.location.assign(`${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirect)}`);
  });

  document.addEventListener('on:cart:after-merge', hydratePromo);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydratePromo, {once: true});
  } else {
    hydratePromo();
  }
})();
